import React, { memo, useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import ReactTable from 'Components/ReactTable/ReactTable';
import {
    Container,
    Grid,
    Paper,
    MenuItem
} from '@material-ui/core';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';

import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    PLEASE_PROVIDE_VALID,
    MESSAGE_CLOSE_AFTER
} from 'Components/Helper/Messages';
import {
    SelectMenuDropDown as MENU_DROPDOWN,
    Insert as INSERT,
    Select as SELECT,
    Delete as DELETE
} from 'Components/Api/AddActionController';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const ActionController = memo(() => {
    const classes = commonStyle();
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [MenuMasterID, setMenuMasterID] = useState(0);
    const [parentMenuList, setParentMenuList] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [IsUpdate, setIsUpdate] = useState(false);
    const [CustomContainerProps, setCustomContainerProps] = useState({
        loadingOpen: false,
        isError: false,
        severity: 'success',
        responseMessage: ''
    });

    const updateCustomContainerProps = (key, value) => {
        setCustomContainerProps((props) => ({
            ...props,
            [key]: value
        }));
    };

    const [MenuObj, setMenuObj] = useState({
        MenuMasterID: MenuMasterID,
        Controller: '',
        Action: '',
        Description: '',
        MenuMasterGUID: 0
    });
    const MenuValidationSchema = Yup.object({
        Controller: Yup.string().required(PLEASE_PROVIDE_VALID + ' Controller'),
        Action: Yup.string().required(PLEASE_PROVIDE_VALID + ' Action')
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (CustomContainerProps.loading) {
            updateCustomContainerProps('loadingOpen', false);
            return;
        }

        var requestObj = JSON.stringify(values);

        updateCustomContainerProps('isError', false);
        updateCustomContainerProps('loadingOpen', true);

        var response = await INSERT(requestObj);
        if (!response.isAuthorized) LOGOUT();

        setCustomContainerProps({
            loadingOpen: false,
            isError: true,
            responseMessage: response.data
        });

        if (!response.status) {
            updateCustomContainerProps('severity', 'error');
            return;
        }

        updateCustomContainerProps('severity', 'success');

        resetForm(MenuObj);
        reset();

        setTimeout(() => {
            select();
            selectParentMenuDropdown();
        }, MESSAGE_CLOSE_AFTER);
    };
    const reset = () => {
        setIsUpdate(false);
        setMenuObj({
            MenuMasterID: 0,
            Controller: '',
            Action: '',
            Description: '',
            MenuMasterGUID: 0
        });
    };

    useEffect(() => {
        updateCustomContainerProps('loadingOpen', true);
        selectParentMenuDropdown();
        select();
        createColumns();
    }, []);

    const selectParentMenuDropdown = async () => {
        updateCustomContainerProps('loadingOpen', true);
        const response = await MENU_DROPDOWN();
        updateCustomContainerProps('loadingOpen', false);

        const { isAuthorized, status, data } = response;
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setCustomContainerProps({
                isError: true,
                severity: 'error',
                responseMessage: response.data
            });
            return;
        }
        var dataList = JSON.parse(data);

        setParentMenuList(dataList);
    };

    const select = async () => {
        updateCustomContainerProps('loadingOpen', true);
        const response = await SELECT();
        updateCustomContainerProps('loadingOpen', false);

        const { isAuthorized, status, data } = response;
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setCustomContainerProps({
                isError: true,
                severity: 'error',
                responseMessage: response.data
            });
            return;
        }
        var dataList = JSON.parse(data);


        setItemList(dataList);
    };
    const createColumns = () => {
        var columns = [];
        columns.push({
            label: '#',
            name: 'MenuActionMappingID',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'Name'
        });

        columns.push({
            label: 'URL',
            name: 'URL'
        });

        columns.push({
            label: 'Controller',
            name: 'Controller'
        });

        columns.push({
            label: 'Action',
            name: 'Action'
        });

        columns.push({
            label: 'Delete',
            name: 'MenuActionMappingID',
            delete: true,
            callback: (row) => {
                onDeleteClick(row);
            }
        });
        setMainColumns(columns);
    };

    const onDeleteClick = (item) => {
        var RequestObj = { MenuActionMappingID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const Delete = async (request) => {
        var jsonReq = JSON.stringify(request);

        updateCustomContainerProps('loadingOpen', true);
        const response = await DELETE(jsonReq);

        updateCustomContainerProps('loadingOpen', false);
        updateCustomContainerProps('isError', true);

        if (!response.isAuthorized) LOGOUT();

        setCustomContainerProps({
            loadingOpen: false,
            isError: true,
            responseMessage: response.data
        });

        setTimeout(() => {
            select();
        }, MESSAGE_CLOSE_AFTER);
    };

    const MenuDropdownList = parentMenuList.map(
        ({ GUID, Name }, index) => (
            <MenuItem key={index} value={GUID}>
                {Name}
            </MenuItem>
        )
    );
    return (
        <CustomContainer
            isLoading={CustomContainerProps.loadingOpen}
            isError={CustomContainerProps.isError}
            alertMessage={CustomContainerProps.responseMessage}
            severity={CustomContainerProps.severity}
            onCloseCallback={(alertState) => {
                updateCustomContainerProps('isError', alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={MenuObj}
                validationSchema={MenuValidationSchema}
                onSubmit={handleSubmit}
                resetForm={MenuObj}
            >
                {({ setFieldValue }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                MenuMapping{' '}
                            </h2>

                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            {' '}
                                            <MaterialSelect
                                                label="Parent Menu"
                                                name="MenuMasterGUID"
                                                title="Select Parent Menu"
                                            >
                                                <MenuItem key="0" value={0}>
                                                    Select Menu
                                                </MenuItem>
                                                {MenuDropdownList}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialTextField
                                                label="Controller"
                                                name="Controller"
                                                type="text"
                                                placeholder="Controller"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialTextField
                                                label="Action"
                                                name="Action"
                                                type="text"
                                                placeholder="Action"
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2} lg={2}>
                                            <PrimaryButton
                                                type="submit"
                                                title="Save"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={
                                                    CustomContainerProps.loading
                                                }
                                            >
                                                Save
                                            </PrimaryButton>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2} lg={2}>
                                            <SecondaryButton
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </SecondaryButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this Menu?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
            <h2 className={classes.PaperHead_h2}>Menu Master</h2>
            <ReactTable
                data={itemList}
                columns={mainColumns}
                rowsPerPage={100}
            />
        </CustomContainer>
    );
});
